import React from 'react';
import PropTypes from 'prop-types';
import ListingItem from './ListingItem';
import ListingItemSkeleton from './ListingItemSkeleton';
import LocalizedMessage from "react-l10n";

function Listing(props) {
    const { isLoading, list } = props;

    const renderLoading = () => {
        return (
            <div className='card'>
                <div className='store-list'>
                    {[...Array(12)].map((_, key) => (
                        <ListingItemSkeleton key={key} />
                    ))}
                </div>
            </div>
        );
    };

    if (isLoading) {
        return renderLoading();
    }

    return (
        <div className='card'>
            <div className='store-list'>
                {list.length > 0 ? (
                    <React.Fragment>
                        {list.map((item) => (
                            <ListingItem item={item} key={item.ID} />
                        ))}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className='text-box text-box--center'>
                            <p><LocalizedMessage id={'FIELD.NO_STORES_MATCHING'} /></p>
                        </div>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}

// default props
Listing.defaultProps = {
    isLoading: false,
    list: [],
};
// validate props
Listing.propTypes = {
    isLoading: PropTypes.bool,
    list: PropTypes.array,
};

export default Listing;
